/* global appData */

import { mapState } from 'vuex';

// Mixins
import { RestComponent } from '../../mixins/rest-component';

// Template and media files
import template from './sidebar.vhtml';
import burgerIcon from '../../../_img/icons/burger.svg';
import back from '../../../_img/icons/back.svg';
import logo from '../../../_img/logo-esbjerghavn.svg';

export default {
	template: template,
	components: {
		burgerIcon,
		back,
		logo,
	},
	mixins: [
		RestComponent,
	],
	data: () => ({
	}),
	computed: {
		show_pers() {
			return false;
		},
		isRoot: vm => vm.$route.path == '/' || vm.showAppsOverview,
		appTitle: () => appData.title.length > 0 ? appData.title : '',
		sidebarClasses: vm => ['sidebar', {
			'sidebar--transparent-until-lg': vm.transparentUntilLg && !vm.appOverviewIsOpen,
			'sidebar--border-right': vm.sidebarPos == 'left',
			'sidebar--border-left': vm.sidebarPos == 'right',
		}],
		iconInnerClasses: vm => ['sidebar__icon-inner', {
			'sidebar__icon-inner--has-arrow': !vm.isRoot,
		}],
		arrowClasses: vm => ['sidebar__icon-arrow', {
			'sidebar__icon-arrow--hidden': vm.isRoot,
		}],
		logoClasses: vm => ['sidebar__logo', {
			'sidebar__logo--white-until-lg': vm.transparentUntilLg && !vm.appOverviewIsOpen,
		}],
		burgerClasses: vm => ['sidebar__burger-icon', {
			'sidebar__burger-icon--hidden-from-lg': !vm.isRoot,
		}],
		burgerDotsClasses: vm => ['o-burger__dots', {
			'o-burger__dots--close': vm.appOverviewIsOpen,
			'o-burger__dots--white-until-lg': vm.transparentUntilLg && !vm.appOverviewIsOpen,
		}],
		shownUrl: vm => vm.parent !== '/' ? '/'+appData.base+vm.parent : appData.base,
		...mapState({
			parent: state => state.sidebar.parent,
			transparentUntilLg: state => state.sidebar.transparentUntilLg,
			sidebarPos: state => state.sidebar.sidebarPos,
			showAppsOverview: state => state.sidebar.showAppsOverview,
			appOverviewIsOpen: state => state.apps.isOpen
		}),
		sidebarSelection() {
			if(this.firstSelectionLabel.length > 50) {
				return this.firstSelectionLabel.substring(0, 50) + '...';
			} else {
				return this.firstSelectionLabel;
			}
		}
	},
	methods: {
		toogleAppsOverview() {
			this.$store.commit('apps/updateData', {
				name: 'isOpen',
				value: !this.appOverviewIsOpen,
			});
		}
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/sidebar/sidebar.js